import { useTranslation } from 'react-i18next';
import { TableV2 } from '@anytag/shared-atoms';
import { TableData } from '@anytag/shared-types';
import { AutoManagedJoinedInfluencer } from '@anytag/graphql';
import { useAutoManagedJoinedInfluencersFilter } from '../AutoManagedJoinedInfluencersFilter';
import { useAutoManagedJoinedInfluencersTable } from './hooks';

export type AutoManagedJoinedInfluencersListProps = TableData<AutoManagedJoinedInfluencer>;

export const AutoManagedJoinedInfluencersList = ({ loading, data = [] }: AutoManagedJoinedInfluencersListProps) => {
  const { t } = useTranslation();
  const { filter } = useAutoManagedJoinedInfluencersFilter();
  const { columns } = useAutoManagedJoinedInfluencersTable();

  return (
    <TableV2
      loading={loading}
      data={data}
      columns={columns}
      rowHeight="66px"
      empty={{ description: filter.keyword ? undefined : t('Nobody joined this campaign yet') }}
      noTopBorderRadius
    />
  );
};
